<template>
  <div class="top-item">
    <router-link :to="{ name: 'video', params: { vid: this.item.id } }">
      <img :src="imgUrl" :alt="item.pagetitle" />
      <div class="item-overlay">
        <was-watched :video="`${item.id}`"></was-watched>
      </div>
      <div class="mask">
        <h3>{{ item.pagetitle }}</h3>
        <div class="item-duration">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M17 13.9L16.3 15.2L11 12.3V7H12.5V11.4L17 13.9Z"
            />
          </svg>
          <span>{{ item.videoDuration }} דק’</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import WasWatched from "@/components/video_page/WasWatched_v2.vue";
export default {
  components: {
    WasWatched,
  },
  props: {
    item: Object,
  },
  computed: {
    imgUrl() {
      if (this.item && this.item.ch) {
        return this.$store.state.initialData.basepath + this.item.ch.trim();
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
.top-item {
  width: 320px;
  height: 186px;
  position: relative;
  margin-left: 2rem;
  margin-bottom: 2rem;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
  a {
    color: #000000;
  }
  img {
    max-width: 290px;
    height: 186px;
  }
  .item-overlay {
    position: absolute;
    top: 0;
    left: 66%;
    right: 0;
    bottom: 0;
    padding: 0.5rem;
    z-index: 30;
    div {
      position: absolute;
      right: 0;
    }
    img {
      height: auto;
    }
  }
  .mask {
    width: 66%;
    min-height: 100%;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #ffffff;
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  h3 {
    font-weight: bold;
  }
  .item-duration {
    background-color: #f2f2f2;
    color: #838383;
    padding: 0 5px;
    border-radius: 20px;
    width: 90px;
    height: 35px;
    line-height: 35px;
    svg {
      position: relative;
      top: 6px;
      margin: 0 2px;
      -webkit-transform: scale(0.8);
      transform: scale(0.8);
    }
    img {
      position: relative;
      top: 6px;
      margin: 0 2px;
      max-height: 24px;
      max-width: 24px;
      width: auto;
      height: auto;
    }
  }
}
</style>